<script>
	import { Col, Row } from "sveltestrap";
	import SidePopup from "../../../components/SidePopup/SidePopup.svelte";
	import { dateRange } from "src/utils/misc";
	import CustomDropdown from "../../../components/CustomDropdown/CustomDropdown.svelte";
	export let task;
	export let toggleDetails;
	export let lookups;
</script>

<SidePopup {toggleDetails}>
	<div class="popup-top popup-item">
		<div class="d-flex justify-content-between">
			<div class="d-flex align-items-center">
				<b>{task["Vehicle No."]}</b>
			</div>
			<CustomDropdown
				alignRight
				options={lookups.vehicleStatuses}
				value={task["Car Status"]}
				isOpen={false}
				chevron={false}
				noElipsis={true}
			/>
		</div>
		<div>
			<b>{task.Vehicle}</b>
		</div>
	</div>
	<div class="popup-mid">
		<Row class="popup-item">
			<Col xs={6}>
				<div class="popup-header">Task</div>
				<div>{task.Task}</div>
			</Col>
		</Row>
		<Row class="popup-item">
			<Col xs={6}>
				<div class="popup-header">Reported by</div>
				<div>{task.ReportedBy}</div>
			</Col>
			<Col xs={6}>
				<div class="popup-header">Priority</div>
				<div>{lookups.taskPriorities[task.Priority].name}</div>
			</Col>
		</Row>
		<Row class="popup-item">
			<Col xs={12}>
				<div class="popup-header">Remarks</div>
				<div>{task.Remarks ? task.Remarks : "No remarks."}</div>
			</Col>
		</Row>
	</div>
	<div class="popup-mid">
		<div class="popup-item">
			<div class="popup-header">
				<span>
					Bookings ({task.Bookings ? task.Bookings.length : 0})
				</span>
			</div>
			{#if !task.Bookings}
				<div>No bookings</div>
			{:else}
				{#each task.Bookings as booking}
					<div>
						{dateRange(booking.start, booking.end)}
					</div>
				{/each}
			{/if}
		</div>
	</div>
	<div class="popup-bottom">
		<div class="popup-item">
			<div class="popup-header">Region</div>
			<div>{task.Region}</div>
		</div>
		<div class="popup-item">
			<div class="popup-header">Address</div>
			<div>{task.Address}</div>
		</div>
	</div>
</SidePopup>

<style>
	.popup-top {
		border-bottom: 1px solid #e8e8e8;
		padding-bottom: 10px;
		margin-bottom: 10px;
	}

	:global(.popup-mid) {
		border-bottom: 1px solid #e8e8e8;
	}

	:global(.popup-item) {
		margin-top: 1em;
		margin-bottom: 1em;
	}

	.popup-header {
		color: #595959;
	}

	.status {
		padding: 4px 18px;
		border-radius: 8px;
		color: white;
	}

	.active {
		background-color: #248a3d;
	}
	.inactive {
		background-color: #d60c0c;
	}
</style>
